<template>
  <li class="nav-main-item">
    <a
      class="nav-main-link"
      href="javascript:void"
      v-on:click.prevent="showcart"
    >
      <i class="nav-main-link-icon fas fa-shopping-basket"></i>
      <span class="nav-main-link-name">{{ !$_.isEmpty(cart) ? cart.total_excl_with_discount_and_promocodes : 0 | currency }}</span>
    </a>
    <!-- <ul class="nav-main-submenu nav-main-submenu-right bg-white font-size-sm" style="min-width: 400px;">
      <div class="p-2 bg-primary text-center d-flex">
        <h5 class="dropdown-header text-uppercase text-white">Winkelwagen</h5>
      </div>
      <ul class="nav-items mb-0">
        <li v-if="$_.isEmpty(cart) || (cart && cart.cart_items && cart.cart_items.length === 0)">
          <div class="py-2 ml-3">
            Winkelwagen is leeg!
          </div>
        </li>
        <div v-if="!$_.isEmpty(cart)">
          <li v-for="item in groups.slice(0, 6)" :key="item.id">
            <a class="d-flex align-items-center text-dark media py-2">
              <div class="mr-2 ml-3"></div>
              <div class="media-body pr-2">
                <template v-if="item.user_package_id">
                  <div class="font-w600">
                    {{ item.type === '1' ? 'Linkpakket toegevoegd' : 'Linkpakket verlengd' }} {{ item.user_package.package.name }}
                  </div>
                  <small class="text-muted">{{ item.title }}</small>
                </template>
                <template v-else>
                  <div class="font-w600">{{ item.type === '1' ? 'Nieuwe link' : 'Link verlenging' }} op {{ item.site.name }}</div>
                  <small class="text-muted">{{ item.title }}</small>
                </template>
              </div>
              <div class="ml-2">
                <span class="mr-2">{{ item.period }} Jaar</span>
                <span class="mr-2">{{ item.user_package_id ? item.user_package.package.price : item.discount_amount | currency }}</span>
                <a class="text-muted mr-3" href="javascript:void" v-on:click.prevent="remove(item.id)"><i class="far fa-trash-alt"></i></a>
              </div>
            </a>
          </li>
          <li v-if="cart.user_discount">
            <a class="d-flex align-items-center text-dark media py-2">
              <div class="mr-2 ml-3"></div>
              <div class="media-body pr-2">
                <div class="font-w600 text-primary">Uw {{ parseInt(cart.user.discount.value) }}% gebruikerskorting</div>
              </div>
              <div class="ml-2">
                <span class="mr-2">{{ cart.user_discount | currency }}</span>
                <a class="text-muted mr-3 invisible" href="javascript:void"><i class="far fa-trash-alt"></i></a>
              </div>
            </a>
          </li>
        </div>
      </ul>
      <div class="p-2 border-top">
        <a class="btn btn-sm btn-light btn-block text-center" v-on:click="showcart"> <i class="fa fa-fw fa-arrow-down mr-1"></i> Bekijken </a>
      </div>
    </ul> -->
  </li>
</template>

<script>
import moment from 'moment';
import { mapActions, mapState } from 'vuex'
import EventBus from '../plugins/vue-event-bus';

export default {
  data: () => {
    return {};
  },
  created: async function() {
    if (_.isEmpty(this.cart)) {
      await this.getCart();
    }

    EventBus.listen('cart.refresh', async () => {
      await this.getCart();
    });

    EventBus.listen('cart.remove', (id) => {
      this.removeFromCart(id);
    });
  },
  computed: {
    ...mapState('cart', ['cart', 'loading']),
    groups: function() {
      if (!this.cart.cart_items) return [];

      let groups = [];
      Object.values(_.groupBy(this.cart.cart_items, 'user_package_id')).forEach((group) => {
        if (group && group[0].user_package_id) {
          groups.push({
            ...group[0],
            title: `${group.length} links`,
          });
        } else {
          group.forEach((link) => {
            groups.push(link);
          });
        }
      });

      return groups.sort((a, b) => {
        if (moment(a.updated_at).isAfter(moment(b.updated_at))) {
          return -1;
        }

        if (moment(a.updated_at).isBefore(moment(b.updated_at))) {
          return 1;
        }

        return 0;
      });
    },
  },
  methods: {
    ...mapActions('cart', ['getCart', 'removeFromCart']),
    showcart: function() {
      window.location = route('cart.index');
    },
  },
};
</script>
